export type StoredAuthTokens = {
  accessToken: string;
  refreshToken: string;
  issuedAtMs: number;
  expiresInSec: number;
  scope?: string;
  userId?: number;
};

const STORAGE_KEY = 'vmonad.auth.tokens.v1';

export function getAccessTokenExpiresAtMs(tokens: StoredAuthTokens): number {
  return tokens.issuedAtMs + tokens.expiresInSec * 1000;
}

export function getRefreshAtMs(tokens: StoredAuthTokens): number {
  return tokens.issuedAtMs + Math.floor(tokens.expiresInSec * 0.75 * 1000);
}

export function isAccessTokenExpired(tokens: StoredAuthTokens, nowMs: number): boolean {
  return getAccessTokenExpiresAtMs(tokens) <= nowMs;
}

export function shouldRefresh(tokens: StoredAuthTokens, nowMs: number): boolean {
  if (isAccessTokenExpired(tokens, nowMs)) return true;
  return getRefreshAtMs(tokens) <= nowMs;
}

export function loadStoredTokens(): StoredAuthTokens | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredAuthTokens;
    if (!parsed?.accessToken || !parsed?.refreshToken || !parsed?.issuedAtMs || !parsed?.expiresInSec) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveStoredTokens(tokens: StoredAuthTokens): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
}

export function clearStoredTokens(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}
